/** Layout visual: logo Mundpay (esquerda) + logo Cademi inclinada (direita). */
const MundCademi = (props) => (
  <svg
    width={88}
    height={56}
    viewBox="0 0 88 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#mc_clip0)">
      <rect
        x={3.50488}
        y={13.8579}
        width={40}
        height={40}
        rx={10}
        transform="rotate(-15 3.50488 13.8579)"
        fill="url(#mc_paint0)"
      />
      <g clipPath="url(#mc_clip1)">
        <path
          d="M26.0782 15.3202L25.2322 16.5812C25.1136 16.7583 24.8855 16.8194 24.6942 16.7253L23.3277 16.0524C23.2183 15.9983 23.0886 15.9925 22.9776 16.039C22.2987 16.321 21.6254 16.6682 20.9644 17.0789C17.4743 19.2485 15.2675 23.0547 15.1143 27.1758C14.8342 34.8436 20.5852 40.395 27.1835 40.829C28.543 40.9176 29.9398 40.7911 31.3277 40.4192C32.7157 40.0473 33.9886 39.4584 35.1217 38.702C39.5809 35.7222 41.8726 30.0987 40.4028 24.6132C38.7155 18.3162 32.6423 14.343 26.374 15.1313C26.2525 15.1472 26.1425 15.2148 26.0732 15.3191L26.0782 15.3202ZM18.1565 31.7824L18.1581 31.7795L21.9767 30.7564C22.1772 30.8671 22.294 30.9311 22.4923 31.0424C23.3437 33.6622 24.4822 35.8833 25.7497 37.5145C25.9995 37.8361 25.7041 38.2918 25.3113 38.1897C22.1249 37.3395 19.4058 35.0104 18.1527 31.7858L18.1565 31.7824ZM30.803 38.16C30.7771 38.1693 30.7527 38.1758 30.7284 38.1824C30.704 38.1889 30.6797 38.1954 30.6525 38.2003C29.2126 38.467 26.475 35.7235 24.736 30.4817C24.6595 30.2496 24.7941 29.9991 25.0287 29.9362L31.5413 28.1911C31.776 28.1283 32.0177 28.278 32.0676 28.5172C33.1824 33.9262 32.1811 37.6716 30.803 38.16ZM35.4211 35.4808C35.1348 35.7672 34.6505 35.518 34.7039 35.1153C34.9992 32.9675 34.8453 30.3301 34.1989 27.4838C34.1983 27.4816 34.2005 27.481 34.2005 27.481L33.7102 25.651C33.6494 25.4242 33.4162 25.2889 33.1904 25.3494L18.0246 29.4131C17.7701 29.4813 17.5199 29.3004 17.4919 29.0363C17.1486 25.7894 18.3299 22.6274 20.5518 20.4091C20.8402 20.1221 21.323 20.374 21.2679 20.7796C21.0627 22.2717 21.0753 24.0009 21.3167 25.8761C21.3491 26.1296 21.6028 26.2975 21.8486 26.2317L23.2675 25.8515C23.4712 25.7969 23.6027 25.5972 23.5773 25.3871C23.0534 21.0591 23.9675 18.1569 25.1698 17.7299L25.3182 17.6901C26.573 17.4588 28.8178 19.5145 30.526 23.5253C30.609 23.7199 30.8205 23.8276 31.0264 23.7725L32.4431 23.3929C32.6889 23.327 32.8253 23.0569 32.7259 22.819C32.0025 21.0753 31.1465 19.5721 30.2244 18.3798C29.9745 18.0582 30.2682 17.5959 30.6593 17.7008C33.8379 18.5483 36.5496 20.8674 37.807 24.0814C37.8118 24.0992 37.8188 24.1164 37.8235 24.1342L38.4104 26.3244C38.4152 26.3421 38.4199 26.3599 38.4225 26.3783C38.9405 29.7904 37.7495 33.1553 35.4205 35.4785L35.4211 35.4808Z"
          fill="url(#mc_paint1)"
        />
      </g>
    </g>
    <g transform="translate(46, 12) translate(16, 16) rotate(15) scale(1.18) translate(-16, -16)">
      <path
        d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z"
        fill="url(#mc_cademi_bg)"
      />
      <path
        d="M6.0231 6.00369C8.81916 5.9749 11.3892 7.09316 13.4243 9.03463C16.1402 11.9835 16.1037 15.4687 16.1284 19.2688C16.1341 19.7153 16.1402 20.1618 16.1467 20.6083C16.1615 21.6921 16.1721 22.7758 16.1792 23.8596C16.2186 23.7235 16.258 23.5873 16.2987 23.447C16.3517 23.2667 16.4047 23.0864 16.4593 22.9006C16.5113 22.7226 16.5633 22.5445 16.6168 22.3611C17.3333 20.1475 19.1885 18.0365 21.2572 16.9607C21.6255 16.8027 21.9981 16.6547 22.3744 16.5169C22.5608 16.447 22.7473 16.3772 22.9393 16.3053C23.4914 16.1492 23.937 16.1192 24.5072 16.1491C24.5072 16.0152 24.5072 15.8813 24.5072 15.7433C24.3187 15.7266 24.1301 15.7098 23.9359 15.6926C21.6917 15.3536 19.8853 14.3566 18.4127 12.6275C16.9691 10.6684 15.9379 8.46223 15.9761 6.00369C18.7376 5.92811 20.9793 7.02088 23.0853 8.74295C24.7762 10.3784 25.9364 12.8057 25.9989 15.1489C26.0359 18.4646 25.1753 20.677 22.9822 23.197C22.1894 23.9682 21.2056 24.4393 20.2289 24.9376C20.0898 25.0087 19.9506 25.0797 19.8072 25.1529C17.7538 26.157 15.2461 26.2371 13.0689 25.559C10.0925 24.4151 7.95394 22.4709 6.63326 19.5581C6.16486 18.3828 5.99714 17.2586 6.00004 16.001C6.00005 15.7777 6.00007 15.5543 6.00008 15.3242C6.00113 15.0864 6.00218 14.8486 6.00326 14.6035C6.00355 14.3575 6.00384 14.1116 6.00413 13.8581C6.00527 13.0746 6.00781 12.2911 6.0104 11.5076C6.01142 10.9755 6.01235 10.4434 6.01318 9.91126C6.01541 8.60873 6.01881 7.30621 6.0231 6.00369Z"
        fill="url(#mc_cademi_symbol)"
      />
    </g>
    <defs>
      <linearGradient
        id="mc_paint0"
        x1={23.5049}
        y1={13.8579}
        x2={23.5049}
        y2={53.8579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29282C" />
        <stop offset={1} stopColor="#100F11" />
      </linearGradient>
      <linearGradient
        id="mc_paint1"
        x1={10.6936}
        y1={13.8569}
        x2={35.8057}
        y2={35.4541}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="mc_cademi_bg"
        x1={0}
        y1={32.6277}
        x2={31.8152}
        y2={-0.0334167}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8057E" />
        <stop offset={1} stopColor="#FA5A39" />
      </linearGradient>
      <linearGradient
        id="mc_cademi_symbol"
        x1={5.84547}
        y1={1.89066}
        x2={20.364}
        y2={23.1713}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="mc_clip0">
        <rect
          x={3.50488}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.50488 13.8579)"
          fill="white"
        />
      </clipPath>
      <clipPath id="mc_clip1">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(9.62891 17.3936) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default MundCademi;
